import React from 'react';

import * as NotificationHelper from '../../../helpers/notificationHelper';

import { callApi } from 'helpers/callApi/callApi';
import AppModal from 'components/modal/appModal';
import { UnlockClipModalContentProps } from './UnlockClipModal.types';
import { AppTextAreaField } from 'components/form/appTextAreaField';
import AppPartialSubmitForm from 'components/form/appPartialSubmitForm';
import { FormId } from 'constants/formId';
import { DataRequestActionTypes } from 'constants/actionTypes';
import { required } from 'components/form/formValidations';

export const UnlockClipModalContent = ({
  unlockParticipantClip,
  data: { event, participantId },
  id,
  close,
}: UnlockClipModalContentProps) => {
  let reason = '';

  const handleSubmit = () => {
    callApi({
      action: () =>
        unlockParticipantClip(event.id, {
          participantId,
          reason,
        }),
      onSuccess: () => {
        NotificationHelper.success('Successfully unlocked clip!');
        close();
      },
      onFailure: ({
        payload: {
          response: {
            errors: { reason: errorReason },
          },
        },
      }) => {
        if (errorReason) {
          NotificationHelper.error('Reason is not allowed to be empty');
        } else {
          NotificationHelper.error('Something went wrong please check');
        }
      },
    });
  };

  return (
    <AppModal
      id={id}
      title="Unlock Clip"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      <h5>Are you sure you want to unlock this clip?</h5>
      <AppPartialSubmitForm form={FormId.UnlockClip} submitActionType={DataRequestActionTypes.UnlockClip} hideButtons>
        <div>
          <AppTextAreaField
            name="reason"
            label="Reason"
            key="name"
            validate={[required]}
            onChange={e => {
              reason = e.target.value;
            }}
          />
        </div>
      </AppPartialSubmitForm>
    </AppModal>
  );
};
